import React from 'react'
// ##
import ViewOrder from '../../modules/Order/components/ViewOrder'

export default function OrderPage() {
  return <ViewOrder />
}
